export default "__VITE_ASSET__ym72r8qt__"